import { defineComponent, computed, createBlock, createCommentVNode, openBlock, unref, withCtx, createElementVNode, createVNode, toDisplayString } from "vue";
import FlowListbox from "../../components/FlowListbox.vue.js";
import _sfc_main$1 from "../../components/FlowIcon.vue.js";
const _hoisted_1 = {
  class: "header-version-button",
  n: "",
  type: "button"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeaderItemVersionSelect",
  props: {
    versions: {},
    activeVersion: {}
  },
  emits: ["navigate"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const versionOptions = computed(
      () => Object.entries(props.versions).map(([id, label]) => ({
        id,
        label
      }))
    );
    const selectedVersion = computed({
      get: () => versionOptions.value.find(({ id }) => id === props.activeVersion),
      set: (v) => (v == null ? void 0 : v.id) && emit("navigate", v.id, "version")
    });
    return (_ctx, _cache) => {
      return selectedVersion.value ? (openBlock(), createBlock(unref(FlowListbox), {
        key: 0,
        modelValue: selectedVersion.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedVersion.value = $event),
        class: "header-version",
        options: versionOptions.value,
        static: ""
      }, {
        default: withCtx(() => [
          createElementVNode("button", _hoisted_1, [
            createElementVNode("span", null, toDisplayString(selectedVersion.value.label), 1),
            createVNode(unref(_sfc_main$1), {
              class: "header-version-icon",
              icon: "ChevronDown",
              width: "14px"
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "options"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=HeaderItemVersionSelect.vue.js.map
